module.exports = __webpack_public_path__ + "static/media/Doctor.93f64b40.png";